var _rect, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#09041C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2155_2628",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 11,
    width: 14,
    height: 14
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9863 24.9863V11.0137H11.0137V24.9863H24.9863Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.0273438
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2155_2628)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7757 14.7288C11.5472 14.5766 11.4102 14.3205 11.4102 14.0461V14.0454C11.4102 13.5605 11.8034 13.1673 12.2884 13.1673H23.7116C24.1966 13.1673 24.5898 13.5605 24.5898 14.0454V14.0459V14.0461C24.5898 14.3205 24.4527 14.5766 24.2243 14.7288C23.1095 15.4722 19.7504 17.7114 18.4874 18.5536C18.1922 18.7504 17.8078 18.7504 17.5126 18.5536C16.2495 17.7114 12.8905 15.4722 11.7757 14.7288Z",
    stroke: "white",
    strokeWidth: 0.820313,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4102 14.0456V21.9534C11.4102 22.1864 11.5026 22.4098 11.6676 22.5746C11.8323 22.7396 12.0557 22.832 12.2888 22.832H23.7112C23.9442 22.832 24.1676 22.7396 24.3323 22.5746C24.4973 22.4098 24.5898 22.1864 24.5898 21.9534V14.0456",
    stroke: "white",
    strokeWidth: 0.820313,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mail-icon.0509373afdd2134a38956b6b3e95728c.svg";
export { ForwardRef as ReactComponent };